import type { ReactNode } from "react";

/**
 * Presents a shell's sidebar over the content on narrow windows: a dimmed backdrop that closes it
 * on click, and the sidebar sliding in from the left. Inline (no wrapper) otherwise.
 */
export function SidebarOverlay({ overlay, onDismiss, children }: { overlay?: boolean; onDismiss: () => void; children: ReactNode }) {
  if (!overlay) return <>{children}</>;
  return (
    <div className="fixed inset-0 z-40 flex">
      <div aria-hidden className="absolute inset-0 animate-fade-in bg-black/25" onClick={onDismiss} />
      <div className="relative flex h-full max-w-[85vw] animate-slide-in bg-sidebar shadow-pop [&>aside]:max-w-full">{children}</div>
    </div>
  );
}
